<template>
    <div class="container">
        <div class="row page-content">
            <div class="col-12 mb-3">
                <h1 class="page-heading text-dark">
                    <img src="/assets/dipocaco/pocas/collection.png" alt="collection-poca" class="page-poca">
                    {{ $t('collections.title') }}
                </h1>
            </div>

            <div class="col-12 mb-4" style="white-space: nowrap">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation" v-on:click="tab = 'sets'">
                        <h5 class="nav-link active" id="sets-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                            {{ $t('collections.tabs.sets') }}
                        </h5>
                    </li>
                    <li class="nav-item" role="presentation" v-on:click="tab = 'custom'">
                        <h5 class="nav-link" id="custom-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                            {{ $t('collections.tabs.custom') }}
                        </h5>
                    </li>
                </ul>
            </div>

            <div class="col-12 row px-0" v-show="tab === 'sets'">
                <h5>{{ $t('collections.bySet') }}</h5>

                <div class="row px-3">
                    <div class="col mb-3 ps-0">
                        <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'en' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='en'">EN <img src="/assets/dipocaco/icons/en.png" alt="" class="language-icon"></a>
                    </div>

                    <div class="col mb-3">
                        <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'ja' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='ja'">JA <img src="/assets/dipocaco/icons/ja.png" alt="" class="language-icon"></a>
                    </div>

                    <div class="col mb-3">
                        <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'de' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='de'">DE <img src="/assets/dipocaco/icons/de.png" alt="" class="language-icon"></a>
                    </div>

                    <div class="col mb-3 pe-0">
                        <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'cn' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='cn'">CN <img src="/assets/dipocaco/icons/cn.png" alt="" class="language-icon"></a>
                    </div>

                    <div class="col mb-3 pe-0">
                        <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'tcgp' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='tcgp'">TCGP</a>
                    </div>
                </div>
            </div>

            <div class="col-12 row px-0" v-show="tab === 'sets'">
                <router-link v-for="collection in setCollections"
                             :key="collection.id"
                             :to="{ name: 'collection', params: { collection_id: collection.id }}"
                             class="col-4 mb-1 collection-router-link"
                             v-show="setFilter === 'tcgp' ? collection.set.set_series === 'Trading Card Game Pocket' : (collection.set.language === setFilter && collection.set.set_series !== 'Trading Card Game Pocket')">

                    <div class="collection-binder">
                        <div class="collection-cover" :style="'background-image: url('+collection.icon_url+')'"></div>
                    </div>

                    <div class="text-center w-100">
                        <small class="muted">
                            {{ collection.name }}
                        </small>
                    </div>
                </router-link>
            </div>

            <div class="col-12 row px-0" v-show="tab === 'custom'">
                <div>
                    <a href="javascript:" class="w-100 mb-3 btn btn-sm btn-success" v-on:click="showCreationModal()">
                        {{ $t('collections.create') }}
                    </a>
                </div>

                <router-link v-for="collection in userCollections"
                             :key="collection.id"
                             :to="{ name: 'collection', params: { collection_id: collection.id }}"
                             class="col-12 col-md-6 col-lg-6 col-xl-4 mb-1 collection-router-link">
                    <div class="collection-binder">
                        <div class="collection-cover user" :style="'background-image: url('+collection.cover_url+')'">

                        </div>
                    </div>
                    <div class="text-center w-100">
                        <small class="muted">
                            {{ collection.name }}
                        </small>
                    </div>
                </router-link>
            </div>

            <div class="modal fade" id="new-collection-modal" tabindex="-1" aria-labelledby="#new-collection-modal-label" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="new-collection-modal-label">
                                {{ $t('collections.create') }}
                            </h1>
                            <button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-body">
                            <div class="form-group">
                                <label for="name" class="label">Name</label>
                                <input type="text" class="form-control" v-model="newCollection.name">
                            </div>

                            <div class="form-group mt-2">
                                <a href="javascript:" class="btn btn-sm btn-success float-end" v-on:click="createCollection">
                                    {{ $t('collections.createButton') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "Collections",
    data() {
        return {
            tab: 'sets',
            collections: [],
            setCollections: [],
            userCollections: [],
            newCollection: {
                name: '',
                icon: '',
                color: '',
                sortBy: '',
                sortOrder: 'desc',
            },
            setFilter: 'en'
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchCollections();

        if (this.$route.params.tab) {
            document.querySelector('#'+this.$route.params.tab+'-tab').click()
            this.tab = this.$route.params.tab;
            this.$forceUpdate();
        }

        if (this.$route.params.filter) {
            this.setFilter = this.$route.params.filter;
        }
    },
    computed: {},
    methods: {
        fetchCollections() {
            axios.get('/api/collections/sets').then((response) => {
                this.setCollections = response.data;
                this.setCollections.sort((a,b) => moment(b.set.release_date).diff(a.set.release_date));
            });

            axios.get('/api/collections/user').then((response) => {
                this.userCollections = response.data;
                this.userCollections.sort((a,b) => a.name.localeCompare(b.name));
            })
        },
        showCreationModal() {
            $("#new-collection-modal").modal('toggle');
        },
        createCollection() {
            if (!this.newCollection.name.trim().length) {
                iziToast.warn({title: this.$i18n.t('collections.notifications.define')});
                return false;
            }

            axios.post('/api/collection/create', this.newCollection).then((response) => {
                iziToast.success({title: this.$i18n.t('collections.notifications.created', {name: response.data.name})});
                $("#new-collection-modal").modal('hide');
                this.fetchCollections();
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.page-heading {
    background-image: url("/assets/dipocaco/pocas/collection-poca_sm.jpg");
    background-position: center 45%;
}

</style>
